interface MarketingBannerProps {
  onClose: () => void;
}

const MarketingBanner = ({ onClose }: MarketingBannerProps) => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 pl-4 pr-8 relative">
      <div className="max-w-7xl mx-auto flex items-center">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center justify-center gap-2">
            <i className="ri-gift-line text-xl"></i>
            <span className="font-bold md:text-sm text-[11px]">
              신규 가입 시 첫 수업 50% 할인!
              <br className="block md:hidden" />
              지금 바로 AI 튜터와 함께 시작하세요!
            </span>
          </div>
          <button className="bg-white text-purple-600 px-2 py-1 rounded-full text-sm font-bold hover:bg-gray-100 transition-colors whitespace-nowrap">
            지금 시작하기
          </button>
        </div>
        <button
          onClick={onClose}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white hover:text-gray-200 transition-colors"
        >
          <i className="ri-close-line text-xl"></i>
        </button>
      </div>
    </div>
  );
};

export default MarketingBanner;
